import { useState } from 'react'

type UseModalType = {
  closeModal: () => void
  opened: boolean
  openModal: () => void
}

export const useModal = (): UseModalType => {
  const [opened, setIsOpened] = useState<boolean>(false)
  const openModal = () => setIsOpened(true)
  const closeModal = () => setIsOpened(false)

  return { closeModal, opened, openModal }
}
